<template>
  <div class="fail">
    <global-nav></global-nav>
    <div class="content">
      <p class="icon-wrapper">
        <img src="./fail.png" alt="fail-icon" width="50" height="50">
      </p>
      <p class="success-text">支付失败!</p>
      <p class="explain">{{text}}</p>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import globalNav from 'components/globalnav/GlobalNav'
  import footNav from 'components/footnav/FootNav'
  export default{
    data(){
      return {
        text: '',
      }
    },
    created(){
      this.text = decodeURIComponent(this.$utils.getUrlKey("message")) || '如您在进行订单支付时无法正常报名，则可能当前报名的班级已被其他学员优先购买，您可以尝试购买其它课程。';
    },
    components: {
      globalNav,
      footNav
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .fail
    padding-top: 60px
    .content
      margin: 50px auto 100px
      padding: 0 170px 74px
      width: 1000px
      border: 1px solid #e4e4e4
      box-sizing border-box
      font-size: 0
      .icon-wrapper
        margin-top: 50px
        height: 50px
        text-align: center
      .success-text
        margin-top: 10px
        font-size: 24px
        color: #ff5353
        height: 36px
        font-weight: bold
        line-height: 36px
        text-align center

      .explain
        margin-top: 40px
        font-size: 14px
        color: #888888
        line-height: 20px
        text-align: center
</style>



// WEBPACK FOOTER //
// src/page/fail/Fail.vue